<div [ngStyle]="styles" [ngClass]="[styleClass]">
  <img
    loading="lazy"
    [alt]="alt"
    [ngClass]="[
      'w-full h-full object-cover object-center opacity-0 transition-opacity duration-500 ease-in-out',
      imageLoaded ? 'opacity-100' : '',
      imageClass
    ]"
    [ngStyle]="imageStyles"
    [src]="imageUrl"
    (load)="onImageLoad()"
    (error)="onError()" />
</div>
